import React from "react";
import { BooleanField, Datagrid, List, TextField } from "react-admin";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { SourceHomebaseWarehouseDetail } from "./Constant/Constant";
import { CustomDateField } from "../../../Components/CustomDateField";

const HomebaseWarehouseDetail = (props: any) => {
  let mainId = props.record.mainId != null ? props.record.mainId : 0;
  return (
    <List
      {...props}
      bulkActionButtons={false}
      exporter={false}
      resource={SourceHomebaseWarehouseDetail}
      filter={{ mainId__eq: mainId }}
      sort={{ field: "createdDate", order: "DESC" }}
      actions={false}
    >
      <Datagrid>
        <TextField source="location" />
        <CreatedByField source="createdBy" link={false} />
        <CustomDateField source="createdDate" showTime />
        {/* <CreatedByField source="updatedBy" link={false} />
                <CustomDateField source="updatedDate" showTime /> */}
        <BooleanField source="isActive" />
      </Datagrid>
    </List>
  );
};

export default HomebaseWarehouseDetail;
